import React from 'react';
import PropTypes from 'prop-types';
import QdtComponent from '../components/QdtComponent';

const Component = props => (
  <div id="mashup">
    {props.filters &&
    <div className="row">
      <div className="col-12 col-sm-3 col-md-3 col-lg-3 pb10">
        <QdtComponent
          type="QdtFilter"
          props={{
                cols: ['Interest Rate Date.autoCalendar.Year'],
                single: true,
                placeholder: 'Year',
                showStateInDropdown: true,
                autoSortByState: 1,
                qSortByAscii: -1,
            }}
        />
      </div>
      <div className="col-12 col-sm-3 col-md-3 col-lg-3 pb10">
        <QdtComponent
          type="QdtFilter"
          props={{
            cols: ['Interest Rate Quarter'],
            single: true,
            placeholder: 'Quarter',
            autoSortByState: 1,
            showStateInDropdown: true,
          }}
        />
      </div>
      <div className="col-12 col-sm-3 col-md-3 col-lg-3 pb10">
        <QdtComponent
          type="QdtFilter"
          props={{
                cols: ['Interest Rate Date.autoCalendar.Month'],
                single: true,
                placeholder: 'Month',
                autoSortByState: 1,
                showStateInDropdown: true,
            }}
        />
      </div>
      <div className="col-12 col-sm-3 col-md-3 col-lg-3 pb10 text-right">
        <QdtComponent type="QdtButton" props={{ type: 'clearSelections', title: 'Clear' }} />
      </div>
    </div>
    }
    <div className="row">
      <div className="col-12">
        <QdtComponent type="QdtViz" props={{ id: 'TjhZmee', height: '480px', noSelections: !(props.selections) }} />
      </div>
    </div>
  </div>
);
Component.propTypes = {
  selections: PropTypes.bool,
  filters: PropTypes.bool,
};
Component.defaultProps = {
  selections: true,
  filters: true,
};

export default Component;



// WEBPACK FOOTER //
// ./src/mashup/FederalInterestRate.jsx